import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ComplianceProLayout = lazy(() =>
  import('../components/compliance-pro/ComplianceProLayout').then((m) => ({ default: m.ComplianceProLayout }))
)
const CompProHubPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.HubPage }))
)
const CompProCockpitPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CockpitPage }))
)
const CompProScorePage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ScorePage }))
)
const CompProPosturePage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PosturePage }))
)
const CompProRgpdPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RgpdPage }))
)
const CompProPiaPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PiaPage }))
)
const CompProDsrPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.DsrPage }))
)
const CompProConsentPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ConsentPage }))
)
const CompProLoi25Page = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.Loi25Page }))
)
const CompProCcpaPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CcpaPage }))
)
const CompProSoxPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.SoxPage }))
)
const CompProPciDssPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PciDssPage }))
)
const CompProRegisterPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RegisterPage }))
)
const CompProObligationDetailPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ObligationDetailPage }))
)
const CompProGapAnalysisPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.GapAnalysisPage }))
)
const CompProGapDetailPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.GapDetailPage }))
)
const CompProActionsPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ActionsPage }))
)
const CompProTransfersPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.TransfersPage }))
)
const CompProTransferDetailPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.TransferDetailPage }))
)
const CompProFrameworksPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CompProFrameworksPage }))
)
const CompProIso27701Page = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.Iso27701Page }))
)
const CompProNistPrivacyPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.NistPrivacyPage }))
)
const CompProCertificationPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CertificationPage }))
)
const CompProReportExecPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CompProReportExecPage }))
)
const CompProIntegrationPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CompProIntegrationPage }))
)
const CompProAuditTrailPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CompProAuditTrailPage }))
)
const CompProSettingsPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CompProSettingsPage }))
)
const CompProOutilsPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CompProOutilsPage }))
)
const CompProCookieScannerPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CookieScannerPage }))
)
const CompProBreachNotificationWizardPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.BreachNotificationWizardPage }))
)
const CompProDataFlowMapperPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.DataFlowMapperPage }))
)
const CompProConsentAnalyticsPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ConsentAnalyticsPage }))
)
const CompProDSARAutomationPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.DSARAutomationPage }))
)
const CompProPrivacyByDesignPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PrivacyByDesignPage }))
)
const CompProRegulatoryChangeImpactPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RegulatoryChangeImpactPage }))
)
const CompProMultiFrameworkHarmonizerPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.MultiFrameworkHarmonizerPage }))
)
const CompProComplianceCalendarPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CopilotComplianceCalendarPage }))
)
const CompProPolicyLifecyclePage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PolicyLifecyclePage }))
)
const CompProDataBreachSimulatorPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.DataBreachSimulatorPage }))
)
const CompProCrossBorderTransferPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CrossBorderTransferPage }))
)
const CompProPrivacyDashboardPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PrivacyDashboardPage }))
)
const CompProRegulatoryChangeTrackerPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RegulatoryChangeTrackerPage }))
)
const CompProControlMonitoringPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ControlMonitoringPage }))
)
const CompProRegImpactPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RegImpactPage }))
)
const CompProPredictiveCompliancePage = lazy(() =>
  import('../pages/compliance-pro/PredictiveCompliancePage').then((m) => ({ default: m.PredictiveCompliancePage }))
)
const CompProAMLCompliancePage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.AMLCompliancePage }))
)
const CompProAutoValidationPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.AutoValidationPage }))
)
const CompProComplianceCalendarPageV2 = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ComplianceCalendarPage }))
)
const CompProContinuousControlMonitoringPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.ContinuousControlMonitoringPage }))
)
const CompProPolicyManagerPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PolicyManagerPage }))
)
const CompProPrivacyCasesPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PrivacyCasesPage }))
)
const CompProPrivacyEngineeringPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PrivacyEngineeringPage }))
)
const CompProRacmPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RacmPage }))
)
const CompProRegulatoryChangePage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RegulatoryChangePage }))
)
const CompProSampleSelectionPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.SampleSelectionPage }))
)
const CompProSanctionsCompliancePage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.SanctionsCompliancePage }))
)
const CompProSoxCertificationPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.SoxCertificationPage }))
)
const CompProControlsPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.CompProControlsPage }))
)
const CompProQuestionnairesPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.QuestionnairesPage }))
)
const CompProQuestionnaireDetailPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.QuestionnaireDetailPage }))
)
const CompProFrameworkGapPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.FrameworkGapPage }))
)
const CompProAnswerQuestionnairePage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.AnswerQuestionnairePage }))
)
const CompProRoPAGeneratorPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RoPAGeneratorPage }))
)
const CompProPrivacyRiskHeatmapPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.PrivacyRiskHeatmapPage }))
)

export const complianceProRoutes: RouteObject[] = [
  {
    path: '/compliance-pro',
    element: <ComplianceProLayout />,
    children: [
      { index: true, element: <CompProHubPage /> },

      { path: 'hub', element: <CompProHubPage /> },
      { path: 'cockpit', element: <CompProCockpitPage /> },
      { path: 'score', element: <CompProScorePage /> },
      { path: 'posture', element: <CompProPosturePage /> },
      { path: 'rgpd', element: <CompProRgpdPage /> },
      { path: 'pia', element: <CompProPiaPage /> },
      { path: 'dsr', element: <CompProDsrPage /> },
      { path: 'consent', element: <CompProConsentPage /> },
      { path: 'loi25', element: <CompProLoi25Page /> },
      { path: 'ccpa', element: <CompProCcpaPage /> },
      { path: 'sox', element: <CompProSoxPage /> },
      { path: 'pci-dss', element: <CompProPciDssPage /> },
      { path: 'register', element: <CompProRegisterPage /> },
      { path: 'register/:id', element: <CompProObligationDetailPage /> },
      { path: 'gaps', element: <CompProGapAnalysisPage /> },
      { path: 'gaps/:id', element: <CompProGapDetailPage /> },
      { path: 'actions', element: <CompProActionsPage /> },
      { path: 'transfers', element: <CompProTransfersPage /> },
      { path: 'transfers/:id', element: <CompProTransferDetailPage /> },
      { path: 'frameworks', element: <CompProFrameworksPage /> },
      { path: 'iso27701', element: <CompProIso27701Page /> },
      { path: 'nist-privacy', element: <CompProNistPrivacyPage /> },
      { path: 'certification', element: <CompProCertificationPage /> },
      { path: 'report-exec', element: <CompProReportExecPage /> },
      { path: 'integrations', element: <CompProIntegrationPage /> },
      { path: 'audit-trail', element: <CompProAuditTrailPage /> },
      { path: 'settings', element: <CompProSettingsPage /> },
      { path: 'outils', element: <CompProOutilsPage /> },
      { path: 'cookie-scanner', element: <CompProCookieScannerPage /> },
      { path: 'breach-notification-wizard', element: <CompProBreachNotificationWizardPage /> },
      { path: 'data-flow-mapper', element: <CompProDataFlowMapperPage /> },
      { path: 'consent-analytics', element: <CompProConsentAnalyticsPage /> },
      { path: 'dsar-automation', element: <CompProDSARAutomationPage /> },
      { path: 'privacy-by-design', element: <CompProPrivacyByDesignPage /> },
      { path: 'regulatory-change-impact', element: <CompProRegulatoryChangeImpactPage /> },
      { path: 'multi-framework-harmonizer', element: <CompProMultiFrameworkHarmonizerPage /> },
      { path: 'compliance-calendar', element: <CompProComplianceCalendarPage /> },
      { path: 'policy-lifecycle', element: <CompProPolicyLifecyclePage /> },
      { path: 'data-breach-simulator', element: <CompProDataBreachSimulatorPage /> },
      { path: 'cross-border-transfer', element: <CompProCrossBorderTransferPage /> },
      { path: 'privacy-dashboard', element: <CompProPrivacyDashboardPage /> },
      { path: 'regulatory-change-tracker', element: <CompProRegulatoryChangeTrackerPage /> },
      { path: 'control-monitoring', element: <CompProControlMonitoringPage /> },
      { path: 'reg-impact', element: <CompProRegImpactPage /> },
      { path: 'predictive-compliance', element: <CompProPredictiveCompliancePage /> },
      { path: 'aml', element: <CompProAMLCompliancePage /> },
      { path: 'auto-validation', element: <CompProAutoValidationPage /> },
      { path: 'calendar', element: <CompProComplianceCalendarPageV2 /> },
      { path: 'ccm', element: <CompProContinuousControlMonitoringPage /> },
      { path: 'policy-manager', element: <CompProPolicyManagerPage /> },
      { path: 'privacy-cases', element: <CompProPrivacyCasesPage /> },
      { path: 'privacy-engineering', element: <CompProPrivacyEngineeringPage /> },
      { path: 'racm', element: <CompProRacmPage /> },
      { path: 'regulatory-change', element: <CompProRegulatoryChangePage /> },
      { path: 'sample-selection', element: <CompProSampleSelectionPage /> },
      { path: 'sanctions', element: <CompProSanctionsCompliancePage /> },
      { path: 'sox-certification', element: <CompProSoxCertificationPage /> },
      { path: 'controls', element: <CompProControlsPage /> },
      { path: 'questionnaires', element: <CompProQuestionnairesPage /> },
      { path: 'questionnaires/:id', element: <CompProQuestionnaireDetailPage /> },
      { path: 'framework-gap', element: <CompProFrameworkGapPage /> },
      { path: 'questionnaire-ia', element: <CompProAnswerQuestionnairePage /> },
      // DPO Copilot — previously-unregistered nav surfaces (SPA/hub fallback fix)
      { path: 'ropa-generator', element: <CompProRoPAGeneratorPage /> },
      { path: 'privacy-risk-heatmap', element: <CompProPrivacyRiskHeatmapPage /> },
      // cross-border-analyzer reuses the Schrems-II cross-border transfer surface
      { path: 'cross-border-analyzer', element: <CompProCrossBorderTransferPage /> },
    ],
  },
]
